/**
 * Module dependencies.
 */

import React, { ReactNode } from 'react';
import { Label } from '../label/label';
import { cn } from 'app/lib/utils';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  label?: string;
  children: ReactNode;
};

/**
 * Export `FormField` component.
 */

export function FormField({ className, label, children }: Props): JSX.Element {
  return (
    <div className={cn('w-full max-w-[520px] pb-5', className)}>
      {label && <Label>{label}</Label>}

      {children}
    </div>
  );
}
